import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';

export function getPendingPayments(body) {
    return axios.post(BASE_API + 'api/payment/admin/pdlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + getTokenCredentials()
        }
    })
    .then(response => response)
    .catch(error => {
        if (error.error === -100) {
            return [];
        }
        return error?.response?.data?.message || error;
    });
}

export function registerAdminPayment(body) {
    return axios.post(BASE_API + 'api/payment/admin/pd', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + getTokenCredentials()
        }
    })
    .then(response => response)
    .catch(error => {
        if (error.error === -100) {
            return [];
        }
        return error?.response?.data?.message || error;
    });
}

export function changePaymentStatus(body) {
    return axios.post(BASE_API + 'api/payment/admin/pd/changestatus', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + getTokenCredentials()
        }
    })
    .then(response => response)
    .catch(error => {
        if (error.error === -100) {
            return [];
        }
        return error?.response?.data?.message || error;
    });
}
